export default __webpack_public_path__ + "static/media/arrows-left-right.ffaf75b7.svg";